import React from "react";

/**
 * Build the typing text from a list of names.
 * @param {string[]} names
 * @param {boolean} isAI
 * @returns {string}
 */
const getTypingText = (names, isAI) => {
  if (isAI) return "Flex AI is thinking…";
  if (names.length === 1) return `${names[0]} is typing…`;
  if (names.length === 2) return `${names[0]} and ${names[1]} are typing…`;
  return `${names[0]} and ${names.length - 1} others are typing…`;
};

/**
 * Animated typing/thinking indicator with named text and pulsing dots.
 *
 * @param {Object} props
 * @param {string[]} [props.names=[]] - Names of people currently typing.
 * @param {boolean} [props.isAI=false] - Render the AI "thinking" variant.
 */
export const TypingIndicator = ({ names = [], isAI = false }) => {
  if (!isAI && names.length === 0) return null;

  return (
    <div
      className="flex items-center gap-1.5 text-xs text-gray-500 italic"
      aria-live="polite"
    >
      <span className="flex items-center gap-0.5" aria-hidden="true">
        <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-pulse [animation-delay:0ms]" />
        <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-pulse [animation-delay:150ms]" />
        <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-pulse [animation-delay:300ms]" />
      </span>
      <span>{getTypingText(names, isAI)}</span>
    </div>
  );
};
